import React from 'react';
import './App.css';
import './index.css';
import './Global.css';
import { Provider } from 'react-redux';
import { store } from './app/redux/store';
import RouteNavigation from './app/router';
import { LoadScript } from '@react-google-maps/api';

function AppContent() {
  return (
    <LoadScript
      googleMapsApiKey={
        process.env.REACT_APP_GOOGLE_MAPS_JAVA_SCRIPT_API_KEY || ''
      }
    >
      <RouteNavigation />
    </LoadScript>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  );
}

export default App;
